<template>
  <div>

    <u-modal id="createSetting" title="Добавить" :isModalOpen="isModalOpen" @isModalOpen="isModalOpen = $event" modalSize="lg">
      <form @submit.prevent="createSetting">

        <div class="row">
          <div class="col">
            <div class="mb-3">
              <label for="serviceName">Название (Сайт | База данных | Nginx)</label>
              <input type="text" name="serviceName" v-model="formData.name" class="form-control" id="name">
            </div>
            <div class="mb-3">
              <label for="type">Тип бэкапа</label>
              <select name="type" class="form-select" id="type" v-model="formData.type" @change="changeType">
                <option v-for="type in types" :key="type.value" :value="type.value">{{type.title}}</option>
              </select>
            </div>

            <div v-if="formData.type === 'dir'">
              <div class="mb-3">
                <label for="optionsDir">Адрес папки (/var/www/site)</label>
                <input type="text" name="optionsDir" id="optionsDir" v-model="formData.options.dir" class="form-control">
              </div>
              <div class="mb-3">
                <label for="optionsExclusions">Исключения (абсолютный/относительный/паттерн)</label>
                <input
                    v-for="(exclusion, index) in formData.options.exclusions"
                    :key="index"
                    type="text"
                    name="optionsExclusions"
                    id="optionsExclusions"
                    v-model="formData.options.exclusions[index]"
                    @input="updateExclusion(index)"
                    class="form-control">
              </div>
            </div>

            <div class="mb-3" v-if="formData.type === 'file'">
              <label for="optionsPath">Адрес файла (/etc/nginx/conf.d/site.conf)</label>
              <input type="text" name="optionsPath" id="optionsPath" v-model="formData.options.path" class="form-control">
            </div>

            <div v-if="formData.type === 'db'">
              <div class="mb-3">
                <label for="optionsType">Тип бд</label>
                <select name="optionsType" class="form-select" id="optionsType" v-model="formData.options.type">
                  <option v-for="dbType in dbTypes" :key="dbType.value" :value="dbType.value">{{dbType.title}}</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="optionsUser">Пользователь бд (db_user)</label>
                <input type="text" name="optionsUser" id="optionsUser" v-model="formData.options.username" class="form-control">
              </div>
              <div class="mb-3">
                <label for="optionsPass">Пароль бд (db_password)</label>
                <input type="text" name="optionsPass" id="optionsPass" v-model="formData.options.password" class="form-control">
              </div>
              <div class="mb-3">
                <label for="optionsDB">Название бд (db_site)</label>
                <input type="text" name="optionsDB" id="optionsDB" v-model="formData.options.database" class="form-control">
              </div>
            </div>
          </div>

          <div class="col-5">
            <div class="mb-3">
              <label for="scheduleHour">Час бэкапа (0-23)</label>
              <input type="number" name="scheduleHour" v-model="formData.scheduleHour" class="form-control" id="scheduleHour">
            </div>
            <div class="mb-3">
              <label for="scheduleCountDay">Количество дней</label>
              <input type="number" name="scheduleCountDay" v-model="formData.scheduleCounts.day" class="form-control" id="scheduleCountDay">
            </div>
            <div class="mb-3">
              <label for="scheduleCountMonth">Количество месяцев</label>
              <input type="number" name="scheduleCountMonth" v-model="formData.scheduleCounts.month" class="form-control" id="scheduleCountMonth">
            </div>
            <div class="mb-3">
              <label for="scheduleCountYear">Количество лет</label>
              <input type="number" name="scheduleCountYear" v-model="formData.scheduleCounts.year" class="form-control" id="scheduleCountYear">
            </div>
          </div>
        </div>



        <button type="submit" class="btn btn-primary">Создать</button>
      </form>
    </u-modal>
    <button type="submit" class="btn btn-primary" @click="openForm">Добавить</button>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {useServersStore} from '@/store/servers'
import {useServiceStore} from "@/store/services";
import {useBackupSettingStore} from "@/store/backup-settings";

const serviceStore = useServiceStore()
const service = computed(() => serviceStore.item)

const types = [
  {title: 'Папка', value: 'dir'},
  {title: 'Файл', value: 'file'},
  {title: 'База данных', value: 'db'},
]
const dbTypes = [
  {title: 'MySql', value: 'mysql'},
  {title: 'PostgreSql', value: 'postgresql'},
]

const isModalOpen = ref(false)
const formData = ref({
  serviceId: service.value.id,
  name: '',
  type: types[0].value,
  options: {},
  scheduleCounts: {
    day: 7,
    month: 12,
    year: 5
  },
  scheduleHour: 3
})

const serversStore = useServersStore()
const servers = computed(() => serversStore.items)
serversStore.getList()

function openForm() {
  formData.value.serverId = service.value.serverId ?? servers.value[0].id
  changeType()
  isModalOpen.value = true
}

function changeType() {
  switch (formData.value.type) {
    case 'dir':
      formData.value.options = {dir: '', exclusions: ['']}
      break;
    case 'file':
      formData.value.options = {path: ''}
      break;
    case 'db':
      formData.value.options = {
        type: dbTypes[0].value,
        username: '',
        password: '',
        database: ''
      }
      break;
  }
}

const updateExclusion = (index) => {
  // Если это последнее поле и оно не пустое
  if (index === formData.value.options.exclusions.length - 1 && formData.value.options.exclusions[index].trim() !== '') {
    formData.value.options.exclusions.push('')
  }

  // Если поле пустое и не первое, удаляем его после задержки
  if (index > 0 && formData.value.options.exclusions[index] === '') {
    if (formData.value.options.exclusions[index] === '') {
      if (formData.value.options.exclusions.length > 1) {
        formData.value.options.exclusions.splice(index, 1)
      }
    }
  }
}


const backupSettingStore = useBackupSettingStore()

function createSetting() {
  if(formData.value.options?.exclusions && formData.value.options.exclusions.length > 0) {
    formData.value.options.exclusions = formData.value.options.exclusions.filter(i => i.trim() !== '')
  }
  backupSettingStore.create(formData.value)
      .then(() => {
        backupSettingStore.getList({serviceId: service.value.id})
        isModalOpen.value = false
      })
}

</script>
